import React, { useEffect } from "react";
import { Provider } from "react-redux";
import {
  HashRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation
} from "react-router-dom";
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeContextProvider } from "src/contexts/theme";
import I18n from "src/locales";
import { Store, persistor } from "src/store";
import MainApp from "./mainapp";
import Login from "src/pages/login"
import ForgotPassword from "src/pages/forgotPassword";
import CreateNewAccount from "src/pages/createNewAccount";
import OTP from "src/pages/otp/otp";
import ResetPassword from "src/pages/resetPassword/resetpassword";
import SuccessForgot from "src/pages/successForgot/index";
import Error from "src/pages/error";

// eslint-disable-next-line no-unused-vars
const I = I18n;
const RootConatainer = (props) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const location = useLocation();

  useEffect(() => {
    getAuthStatus();
  }, [location]);

  /** handler functions--------------------------------------------------- **/

  /** Function to retrieve token from localStorage if token present return true otherwise false */
  const getAuthStatus = () => {
    let token = JSON.parse(localStorage.getItem("userDetails"))?.token || '';
    if (token) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeContextProvider Theme={"light"}>
          <Routes>
            <Route path="/app/*" element={getAuthStatus() ? <MainApp /> : <Navigate replace to="/login" />} />
            <Route path="/" element={getAuthStatus() ? <Navigate replace to="/app" /> : <Navigate replace to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/createnew" element={<CreateNewAccount />} />
            <Route path="/forgot" element={<ForgotPassword />} />
            <Route path="/otp" element={<OTP />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/successresetpassword" element={<SuccessForgot />} />
            <Route path="/error" element={<Error />} />
          </Routes>
        </ThemeContextProvider>
      </PersistGate>
    </Provider>
  );
};

export default RootConatainer;
